import PrivacyModal from "components/common/PrivacyModal";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-achromatic-50 flex justify-center py-10 px-4">
      {/* PrivacyModal을 항상 열린 상태로, 닫기 시 메인으로 이동 */}
      <PrivacyModal isOpen={true} onClose={() => window.location.href = "/"} />
    </div>
  );
}
